var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22521 17.5772C4.80424 17.5772 4.44792 17.4314 4.15625 17.1397C3.86458 16.848 3.71875 16.4917 3.71875 16.0707V4.91698C3.71875 4.49601 3.86458 4.13969 4.15625 3.84802C4.44792 3.55636 4.80424 3.41052 5.22521 3.41052H10.81V4.66052H5.22521C5.16104 4.66052 5.10229 4.68726 5.04896 4.74073C4.99549 4.79406 4.96875 4.85281 4.96875 4.91698V16.0707C4.96875 16.1349 4.99549 16.1936 5.04896 16.247C5.10229 16.3005 5.16104 16.3272 5.22521 16.3272H10.81V17.5772H5.22521ZM14.3277 14.0516L13.4623 13.1476L15.4913 11.1189H8.38229V9.86886H15.4913L13.4623 7.84011L14.3277 6.93615L17.8854 10.4939L14.3277 14.0516Z",
    fill: "#189FAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogout);
export default __webpack_public_path__ + "static/media/profileLogout.b30fb0013e21774300a873d37b053e7f.svg";
export { ForwardRef as ReactComponent };